import { lazy } from 'react';

const AdmPageCreateCompanieVerifierConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: true,
					style: 'static'
				},
			}
		}
	},
	routes: [
		{
			path: '/adm/users/company-verifier',
			component: lazy(() => import('./AdmPageCreateCompanieVerifier'))
		}
	]
};

export default AdmPageCreateCompanieVerifierConfig;
